<div class="content">
	<h3 class="text-center">
		@if (isConfirmationStep()) {
		{{ "thank_you_for_completing_the" | translate }}
		} {{ pulseSurvey()?.testName ?? "" | translate }}
	</h3>
	@let _question = currentQuestion(); @if (_question) {
	<div>{{ _question.Text }}</div>
	<p class="text-muted">{{ _question.Description }}</p>
	<div class="questions">
		@for (option of _question.Options; track option.Id) {
		<button
			class="btn d-block w-100"
			[ngClass]="{
            'btn-primary': answers()[_question.Id] === option.Id,
            'btn-salubi-accent': answers()[_question.Id] !== option.Id,
          }"
			(click)="setAnswer(_question.Id, option.Id)"
		>
			{{ option.Text }}
		</button>
		}
	</div>

	<div class="d-flex justify-content-between mt-4">
		@if (!isFirstQuestion()) {
		<app-back-button
			(clicked)="handleBack()"
			[disabled]="currentQuestionIndex() === 0"
		/>
		} @else {
		<div></div>
		}
		<button
			class="btn btn-sm btn-circle btn-primary"
			(click)="handleNext()"
			[disabled]="!isAnsweredCurrent()"
		>
			<img [src]="'arrow-right' | icon" class="filter-white" alt="Next">
		</button>
	</div>
	} @if (isConfirmationStep()) {
	<div class="text-center">
		{{ "pulse_survey_submit_instruction" | translate }}
	</div>
	<div class="d-flex justify-content-between align-items-center mt-4">
		<div class="flex-1">
			<app-back-button
				(clicked)="handleBack()"
				[disabled]="currentQuestionIndex() === 0"
			/>
		</div>
		<div class="flex-1 d-flex justify-content-center align-items-center">
			<button class="btn btn-circle btn-primary" (click)="handleFinish()">
				{{ "Finish" | translate }}
			</button>
		</div>
		<div class="flex-1"></div>
	</div>
	}
</div>
